interface ApiConfig {
  API_KEY: string;
  WRAPPER_API_KEY: string;
  DISCOVER_API_KEY: string;
  geoLocationURL: string;
  discoveryApiURL: string;
  servicePropTypes: string;
  serviceWebCategories: string;
  genericLeadSource: string;
  franchiseLookUpServiceAddress: string;
  bookingApiURL: string;
  captureLeadApiURL: string;
  createLeadApiURL: string;
  fullAttributeURL?: string;
  brandJsonURL?: string;
  brandCANJsonURL?: string;
  techAvailabiltyURL?: string;
  contactUsSend?: string;
  syncSourceLeadTypeThree?: string;
  leadSource?: string;
  dynamicMenu?: string;
  WebLocationsAPI: string;
  presignedUrl: string;
  feeInspection?: string;
  vehicleDetails?: string;
  atomAPI?: string;
  wdgAgnosticUrl?: string;
  priceQuoteUrl?: string;
  revGeoCodeApi?: string;
  applianceBrandURL?: string;
  stateApi?: string;
  feeInspectionWithOutZipCode?: string;
  upsellApi?: string;
  rpmUpsellApi?: string;
  crossSellApi?: string;
  servicePricing?: string;
  estimateLawnSize?: string;
  getQuote?: string;
  postQuote?: string;
  serviceBotUrl?: string;
  salesLawnBotUrl?: string;
  fidJsonURL?: string;
  validateOfferApi?: string;
  serviceOffers?: string;
  isExistingCustomer?: string;
  realGreenApi?: string;
  trendingServicesApi?: string;
  isnRedirectConfigUrl?: string;
  franchisePosLookup?: string;
  gardenAreaLookup?: string;
  initImgUpload?: string;
  uploadcomplete?: string;
  hereMapApiUrl?: string;
  jukGetQuote?: string;
}

const apiUrl = {
  development: "https://api.nblytest.com",
  stage: "https://api.nblytest.com",
  prod: "https://api.neighborly.com",
};

const unifiedsyncplatform = {
  development: "https://api2-test-unifiedsyncplatform.dwyergroup.com",
  stage: "https://api2-test-unifiedsyncplatform.dwyergroup.com",
  prod: "https://api2-unifiedsyncplatform.dwyergroup.com",
};

const bookinAPIWrapper = {
  development: "https://dig-api.nblytest.com",
  stage: "https://dig-api.nblytest.com",
  prod: "https://dig-api.nblyprod.com",
};

const digBookingWrapper = {
  development: "dig-api-lead-orchestration-release",
  stage: "dig-api-lead-orchestration-release",
  prod: "dig-api-lead-orchestration",
};

const contactUsUnifiedsyncplatform = {
  development: "https://api2-test-unifiedsyncplatform.dwyergroup.com",
  stage: "https://api2-test-unifiedsyncplatform.dwyergroup.com",
  prod: "https://api2-unifiedsyncplatform.dwyergroup.com",
};

const JS_ServiceOrchestrations_URL = {
  development: "serviceorchestrations-api-release",
  stage: "serviceorchestrations-api-release",
  prod: "serviceorchestrations-api",
};

const JS_DigitalOrchestrations_URL = {
  development: "digitalorchestrations-api-release",
  stage: "digitalorchestrations-api-release",
  prod: "digitalorchestrations-api",
};

const CAN_PRICING_URL = {
  development: "callcenterorchestrations-api-release",
  stage: "callcenterorchestrations-api-release",
  prod: "callcenterorchestrations-api",
};

const apikey = {
  development: "tneiweb-L0WLDH5bGqSGWEy",
  stage: "tneiweb-L0WLDH5bGqSGWEy",
  prod: "pneiweb-9pbaOywNKQj853D",
};

export const bookingAPIKey = {
  development: "dneiweb-oZlRRNnlSLCWP37",
  stage: "tneiweb-L0WLDH5bGqSGWEy",
  prod: "pneiweb-9pbaOywNKQj853D",
};

const canApiKey = {
  development: "9CFD4409-CF2C-4A60-997E-DC9921F1E432",
  stage: "9CFD4409-CF2C-4A60-997E-DC9921F1E432",
  prod: "9CFD4409-CF2C-4A60-997E-DC9921F1E432",
};

const franchiseGroupApi = {
  development: "franchisegroup-api-release",
  stage: "franchisegroup-api-release",
  prod: "franchisegroup-api",
};

const discoveryApi = {
  development: "1nz-GVrXhtXIjYpS4LQ-sMSaPzQeYJvzjPJsK4vzeDk",
  stage: "1nz-GVrXhtXIjYpS4LQ-sMSaPzQeYJvzjPJsK4vzeDk",
  prod: "1nz-GVrXhtXIjYpS4LQ-sMSaPzQeYJvzjPJsK4vzeDk",
};

export const revGeoCodeKey = {
  development: "NSFzJWiXqllZTvP4jbKP6vNbb_K9NHSIJVKJt0uFfTo",
  stage: "NSFzJWiXqllZTvP4jbKP6vNbb_K9NHSIJVKJt0uFfTo",
  prod: "NSFzJWiXqllZTvP4jbKP6vNbb_K9NHSIJVKJt0uFfTo",
};

const JS_Profile_Service_Api = {
  development: "profileservice-release",
  stage: "profileservice-release",
  prod: "profileservice",
};

export const realGreenApiKey = {
  development: "505fb962-a881-4f75-98e6-7d7fb65e5d03",
  stage: "505fb962-a881-4f75-98e6-7d7fb65e5d03",
  prod: "505fb962-a881-4f75-98e6-7d7fb65e5d03",
};

export const hereMapApiKey = {
  development: "93V7R-Xm7vdRmBDcoY3YOPsWj5hfgzLbYL5KogzHsjA",
  stage: "93V7R-Xm7vdRmBDcoY3YOPsWj5hfgzLbYL5KogzHsjA",
  prod: "93V7R-Xm7vdRmBDcoY3YOPsWj5hfgzLbYL5KogzHsjA",
};

const apiConfig: ApiConfig = {
  API_KEY: apikey[process.env.NODE_ENV || "development"],
  WRAPPER_API_KEY: bookingAPIKey[process.env.NODE_ENV || "development"],
  DISCOVER_API_KEY: discoveryApi[process.env.NODE_ENV || "development"],
  geoLocationURL: "https://geocode.search.hereapi.com/v1/geocode",
  discoveryApiURL: "https://discover.search.hereapi.com/v1/discover",
  servicePropTypes: `${apiUrl[process.env.NODE_ENV || "development"]}/${JS_ServiceOrchestrations_URL[process.env.NODE_ENV || "development"]}/v1/public/protypes/serviceprotypes-aggregates/search`,
  serviceWebCategories: `${apiUrl[process.env.NODE_ENV || "development"]}/${JS_ServiceOrchestrations_URL[process.env.NODE_ENV || "development"]}/v1/public/services/servicewebcategories/serviceprotypes-aggregates/search`,
  franchiseLookUpServiceAddress: `${apiUrl[process.env.NODE_ENV || "development"]}/${JS_DigitalOrchestrations_URL[process.env.NODE_ENV || "development"]}/v1/public/FranchiseLookup/FranchiseLookUpByServiceAddress`,
  genericLeadSource: `${apiUrl[process.env.NODE_ENV || "development"]}/${JS_ServiceOrchestrations_URL[process.env.NODE_ENV || "development"]}/v1/public/generic-lead-sources`,
  fullAttributeURL: `${apiUrl[process.env.NODE_ENV || "development"]}/${franchiseGroupApi[process.env.NODE_ENV || "development"]}/v1/public/fullattribute/franchiseWeblocations/search`,
  captureLeadApiURL: `${bookinAPIWrapper[process.env.NODE_ENV || "development"]}/${digBookingWrapper[process.env.NODE_ENV || "development"]}/v1/public/Booking/capturelead`,
  createLeadApiURL: `${bookinAPIWrapper[process.env.NODE_ENV || "development"]}/${digBookingWrapper[process.env.NODE_ENV || "development"]}/v1/public/Booking/createlead`,
  bookingApiURL: `${unifiedsyncplatform[process.env.NODE_ENV || "development"]}/public/UnifiedSyncPlatform/Booking`,
  brandJsonURL: `${window.location.origin}/_assets-global/configs/brands.json`,
  brandCANJsonURL: `${window.location.origin}/_assets-global/configs/brands-ca.json`,
  contactUsSend: `${contactUsUnifiedsyncplatform[process.env.NODE_ENV || "development"]}/public/UnifiedSyncPlatform/ContactUs`,
  syncSourceLeadTypeThree: `${apiUrl[process.env.NODE_ENV || "development"]}/${JS_ServiceOrchestrations_URL[process.env.NODE_ENV || "development"]}/v1/public/sync-source-types/primary-secondary/lead-sources`,
  leadSource: `${apiUrl[process.env.NODE_ENV || "development"]}/${JS_ServiceOrchestrations_URL[process.env.NODE_ENV || "development"]}/v1/public/concepts/`,
  techAvailabiltyURL: `${apiUrl[process.env.NODE_ENV || "development"]}/unifiedsyncplatform-api/v1/public/UnifiedSyncPlatform/TechAvailability`,
  dynamicMenu: `${window.location.origin}/cesmenu`,
  applianceBrandURL: `${apiUrl[process.env.NODE_ENV || "development"]}/${JS_ServiceOrchestrations_URL[process.env.NODE_ENV || "development"]}/v1/public/concepts/8/makes?&apikey=${apikey[process.env.NODE_ENV || "development"]}`,
  WebLocationsAPI: `${apiUrl[process.env.NODE_ENV || "development"]}/${franchiseGroupApi[process.env.NODE_ENV || "development"]}/v1/public/concepts`,
  presignedUrl: `${apiUrl[process.env.NODE_ENV || "development"]}/${JS_DigitalOrchestrations_URL[process.env.NODE_ENV || "development"]}/v1/public/OnlineSchedulerFileUpload/getpresignedurl`,
  feeInspection: `${apiUrl[process.env.NODE_ENV || "development"]}/${franchiseGroupApi[process.env.NODE_ENV || "development"]}/v1/public/franchiseWebLocationPostalCodeFees`,
  vehicleDetails: `${apiUrl[process.env.NODE_ENV || "development"]}/${JS_DigitalOrchestrations_URL[process.env.NODE_ENV || "development"]}/v1/public/vehicleDetails`,
  atomAPI: `${apiUrl[process.env.NODE_ENV || "development"]}/${JS_DigitalOrchestrations_URL[process.env.NODE_ENV || "development"]}/v1/public/area`,
  wdgAgnosticUrl: `${window.location.origin}/us/en-us/config-files/_agnostic-config.json`,
  priceQuoteUrl: `${apiUrl[process.env.NODE_ENV || "development"]}/${CAN_PRICING_URL[process.env.NODE_ENV || "development"]}/v1/public/pricebook/GetPricingByWebLocation?apikey={${canApiKey[process.env.NODE_ENV || "development"]}}`,
  revGeoCodeApi: "https://revgeocode.search.hereapi.com/v1/revgeocode?at=",
  stateApi: `${apiUrl[process.env.NODE_ENV || "development"]}/${JS_Profile_Service_Api[process.env.NODE_ENV || "development"]}/v1/public/IdentityExperience/States/`,
  validateOfferApi: `${apiUrl[process.env.NODE_ENV || "development"]}/${JS_DigitalOrchestrations_URL[process.env.NODE_ENV || "development"]}/v1/public/coupons/validate?apikey=${apikey[process.env.NODE_ENV || "development"]}`,
  serviceOffers: `${apiUrl[process.env.NODE_ENV || "development"]}/${JS_DigitalOrchestrations_URL[process.env.NODE_ENV || "development"]}/v1/public/coupons/offers`,
  feeInspectionWithOutZipCode: `${apiUrl[process.env.NODE_ENV || "development"]}/${JS_DigitalOrchestrations_URL[process.env.NODE_ENV || "development"]}/v1/public/franchiseWebLocationProfileFees/franchiseWeblocations/`,
  upsellApi: `${window.location.origin}/config-files/upsell.json`,
  rpmUpsellApi: `${globalThis.location.origin}/config-files/alternate-brand-configs/rpm/upsell.json`,
  crossSellApi: `${apiUrl[process.env.NODE_ENV || "development"]}/${JS_DigitalOrchestrations_URL[process.env.NODE_ENV || "development"]}/v1/public/crossSellServices`,
  servicePricing: `${window.location.origin}/config-files/_pricing-config.json`,
  estimateLawnSize: `${apiUrl[process.env.NODE_ENV || "development"]}/${JS_DigitalOrchestrations_URL[process.env.NODE_ENV || "development"]}/v1/public/area`,
  getQuote: `${bookinAPIWrapper[process.env.NODE_ENV || "development"]}/${digBookingWrapper[process.env.NODE_ENV || "development"]}/v1/public/quote`,
  postQuote: `${bookinAPIWrapper[process.env.NODE_ENV || "development"]}/${digBookingWrapper[process.env.NODE_ENV || "development"]}/v1/public/quote`,
  isExistingCustomer: `${apiUrl[process.env.NODE_ENV || "development"]}/${JS_DigitalOrchestrations_URL[process.env.NODE_ENV || "development"]}/v1/public/IsReturnCustomer?apikey=${apikey[process.env.NODE_ENV || "development"]}`,
  salesLawnBotUrl: `https://sales.lawnbot.biz`,
  fidJsonURL: `${window.location.origin}/us/en-us/config-files/_fid-config.json`,
  isnRedirectConfigUrl: `${window.location.origin}/brand/_assets/data/isn_redirect_config.json`,
  franchisePosLookup: `${contactUsUnifiedsyncplatform[process.env.NODE_ENV || "development"]}/UnifiedSyncPlatform/FranchisePosLookup?apikey=${apikey[process.env.NODE_ENV || "development"]}&FranchiseWebLocationId=`,
  realGreenApi: `${apiUrl[process.env.NODE_ENV || "development"]}/${JS_DigitalOrchestrations_URL[process.env.NODE_ENV || "development"]}/v1/public/PaymentMethod/SavedPaymentMethods`,
  trendingServicesApi: `${apiUrl[process.env.NODE_ENV || "development"]}/${JS_DigitalOrchestrations_URL[process.env.NODE_ENV || "development"]}/v1/public/trendingservices`,
  gardenAreaLookup: `${apiUrl[process.env.NODE_ENV || "development"]}/${JS_DigitalOrchestrations_URL[process.env.NODE_ENV || "development"]}/v1/public/gardenArea/lookup`,
  initImgUpload: `${bookinAPIWrapper[process.env.NODE_ENV || "development"]}/${digBookingWrapper[process.env.NODE_ENV || "development"]}/v1/public/Media/initupload`,
  uploadcomplete: `${bookinAPIWrapper[process.env.NODE_ENV || "development"]}/${digBookingWrapper[process.env.NODE_ENV || "development"]}/v1/public/Media/uploadcomplete`,
  hereMapApiUrl: "https://maps.hereapi.com/v3",
  jukGetQuote: `${apiUrl[process.env.NODE_ENV || "development"]}/${JS_DigitalOrchestrations_URL[process.env.NODE_ENV || "development"]}/v1/public/quote`,
};

export default apiConfig;
